<template>
  <div id="app">
    <SWPCalculator />
  </div>
</template>

<script>
import SWPCalculator from "./components/SWPCalculator.vue";

export default {
  name: "App",
  components: {
    SWPCalculator,
  },
};
</script>

<style>
#app {
}
</style>
